export default __webpack_public_path__ + "static/media/ksm-delegate.63584b9c.svg";